import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'
import { Observable } from 'rxjs/internal/Observable';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { DataService } from 'src/app/services/data.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

@Component({
  selector: 'app-payment-config',
  templateUrl: './payment-config.component.html',
  styleUrls: ['./payment-config.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class PaymentConfigComponent {
  addressCountryFormControl! : FormControl; 
  addressStateFormControl! : FormControl;
  addressCityFormControl! : FormControl;
  postalCodeFormCountol !: FormControl;

  countryFilteredOptions: Observable<Country[]>|undefined;
  stateFilteredOptions: Observable<State[]>|undefined;
  cityFilteredOptions: Observable<String[]>|undefined;
  creditStatus:any
  numbers: number[] = Array.from({ length: 50 }, (_, i) => i + 1);
  bankdata:any=[]
  showCredit:boolean=false;
  showMedium:boolean=false;
  showDeposit:boolean=false;
  productdata:any=[]
  cardtypedata:any=[]
  search:any={searchText:""}
  showCreditCardPopup:boolean=false
  groupList:any=[]
  creditRegFg!:FormGroup
  columnsCreditDisplay: string[] = ['enabled','bankName','cardNumber','expiryDate','accountTag','priority','cardType'];
  expandedElement!: any | null;
  totalElements:any=0
  action:any
  CreditData:any
  id:any='lock'
  type:any
  constructor( private data:DataService, private route :ActivatedRoute,private staticDataService : StaticdataService,private customValidator : CustomValidatorsService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
    private PaymentConfigService:PaymentConfigService,private AirManagementService:AirManagementService,    private userPrivileges: UserPrivilegeService,
    ){
      this.userPrivileges.userPrivilegesByModule('Payment-Config').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });
      this.onClickPMedium();
      
     
      this.addressCountryFormControl = new FormControl({countryCode:"IN",countryName : "India"},[this.customValidator.countryValidator()]);
   this.addressStateFormControl = new FormControl({stateCode:'',stateName:''},[this.customValidator.stateValidator(this.addressCountryFormControl)]);
   this.addressCityFormControl = new FormControl('');
   this.postalCodeFormCountol = new FormControl('',this.customValidator.postalCodeValidator(this.addressCountryFormControl));
             
      
   this.route.queryParams.subscribe(params => {
    let data:any
    data=params
if(data.hasOwnProperty('type')){
console.log(this.decodeTransformedcode(data.type))
    if(this.decodeTransformedcode(data.type)==='lockType'){
      this.type=this.decodeTransformedcode(data.type)
    }else{
      this.type='c'
    }
  }
    if(data.id){
      this.id=this.decodeTransformedcode(data.id)
if(this.id==='paymentConfigNull'){
  this.id=null
}
    }
   
   // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
    
    
  
      });
   
    }
    ngOnInit(): void  {
      this.countryFilteredOptions = this.addressCountryFormControl?.valueChanges
      .pipe(
        startWith({} as Country),
        map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
        map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService.countryCache.slice())
      );
      
    this.stateFilteredOptions = this.addressStateFormControl?.valueChanges
    
      .pipe(
        startWith({} as State),
        map((state :State) => state && typeof state === 'object' ? state.stateName : state),
        map((stateName: string) => stateName ? this._filterState(stateName) : this.staticDataService.stateCache.slice())
      );
      this.cityFilteredOptions = this.addressCityFormControl?.valueChanges
      
      .pipe(
        startWith({} as City),
        map((city :City) => city && typeof city === 'object' ? city.cityName : city),
        map((cityName: string) => cityName ? this._filterCity(cityName) : this.staticDataService.cityCache.slice().map(c => c.cityName))
      );
      this.dataFields()
    }
    decodeTransformedcode(encodedEmail: string): string {
      let result = '';
    
      for (let i = 0; i < encodedEmail.length; i += 2) {
        const hexChar = encodedEmail.slice(i, i + 2);
        const charCode = parseInt(hexChar, 16); // Convert the hexadecimal string to a character code
        result += String.fromCharCode(charCode);
      }
    
      return result;
    }
  dataFields(){
    this.creditRegFg=this.fb.group({
      "priority" :  [''],
      "product" : [''],
      "sources":['',[Validators.required]],
      "sourceType" : [],
      "subProduct" : [''],
      "branch":[null],
      "travelType":[''],
      "group" : ['',[Validators.required]],
      "cardType" : ['',[Validators.required]],
      "cardNumber" : ['',[Validators.required]],
      "holderName":['',[Validators.required]],
      "bankName" : ['',[Validators.required]],
      "expiryDate" : ['',[Validators.required,this.mmYyyyValidator]],
      "minimumPassthroughAmount" : ['',],
      "street" : ['',],
      "city":this.addressCityFormControl,
      "accountsTag" : ['',[Validators.required]],
      "state":this.addressStateFormControl,
      "country" : this.addressCountryFormControl,
      "pinCode" : this.postalCodeFormCountol,
      "cvv":[''],
      "status":['A'],
      "airport": ["#"],
    "reseller": ["#"],
    "dayOfMonth": "#"
    });
  }
  filter:any={
    airportExclude: '',
    resellerExclude: '',
    dayOfMonthExclude:'',
    airportInclude: 'I',
    resellerInclude: 'I',
    dayOfMonthInclude:'I'
  }
  branchData:any=[]
branchList(){

 this.AirManagementService
 .branchlist()
 .subscribe({
   next : (res:any) => {
     if(res) {
    this.branchData=res
  
     } else {
     
     } 
   },error : (err) => {

   }
 }
)
}
  closePopup() {
    this.showCreditCardPopup=false
    
    this.dataFields()
  }
  privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

  backClick(){
   // window.location.href="/app/settings"
   this.location.back()

      } 
      rowGroupClick(element:any){
        this.sourceCodelist()

        this.cardTypeList();
        this.bankList();
        this.sourceCodelist()
         
          
         if(element.state && element.country){
         
         
           let state=this._filterStateByCode(element.state)
           let country=this._filterCountryByCode(element.country)
           console.log(country)
           console.log(state)
           this.addressCountryFormControl = new FormControl({countryCode:country[0].countryCode,countryName : country[0].countryName},[Validators.required,this.customValidator.countryValidator()]);
          this.addressStateFormControl = new FormControl({stateCode:state[0]?.stateCode,stateName:state[0]?.stateName},[Validators.required,this.customValidator.stateValidator(this.addressCountryFormControl)]);
          this.addressCityFormControl = new FormControl(element.city,[Validators.required]);
          this.postalCodeFormCountol = new FormControl(element.pinCode,this.customValidator.postalCodeValidator(this.addressCountryFormControl));
                    
         }


        this.action="updatecredit"
        this.showCreditCardPopup=true
        this.creditRegFg=this.fb.group({
          "priority" :  [element?.priority.toString()],
          "sources":[element.sources,[Validators.required]],
          "product" : [element?.product],
          "sourceType" : [element?.sourceType],
          "branch":[element?.branch?.split(',')||[]],
          "travelType":[element?.travelType||''],
          "subProduct" : [element?.subProduct],
          "group" : [element?.group,[Validators.required]],
          "cardType" : [element?.cardType,[Validators.required]],
          "cardNumber" : [element?.maskedCardNumber,[Validators.required]],
          "holderName":[element?.holderName,[Validators.required]],
          "bankName" : [element?.bankName,[Validators.required]],
          "expiryDate" : [element?.expiryDate,[Validators.required,this.mmYyyyValidator]],
          "minimumPassthroughAmount" : [element?.minimumPassthroughAmount],
          "street" : [element?.street,],
          "city":this.addressCityFormControl,
          "accountsTag" : [element?.accountsTag,[Validators.required]],
          "state":this.addressStateFormControl,
          "country" : this.addressCountryFormControl,
          "pinCode" : this.postalCodeFormCountol,
          "cvv":[],
          "status":[element?.status],
          "airport": [element?.airport],
    "reseller": [element?.reseller],
    "dayOfMonth": [element?.dayOfMonth]
        });


        this.filter={
          airportExclude: this.creditRegFg.value.airport.split('#')[1],
          resellerExclude: this.creditRegFg.value.reseller.split('#')[1],
          dayOfMonthExclude:this.creditRegFg.value.dayOfMonth.split('#')[1],
          airportInclude: this.creditRegFg.value.airport.split('#')[0],
          resellerInclude: this.creditRegFg.value.reseller.split('#')[0],
          dayOfMonthInclude:this.creditRegFg.value.dayOfMonth.split('#')[0]
        }
        
        if(element?.status==='I'){
          this.creditStatus=false
        }else if(element?.status==='A'){
          this.creditStatus=true
        }
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
      searchUser(){

      }
      onAddCredit(){
        this.cardTypeList();
        this.bankList();
        this.showCreditCardPopup=true
        this.action="newcredit";
      }

      onClickPMedium(){
        this.ProductList();
        this.cardTypeList();
        this.bankList();
        this.Grouplist();
        this.showMedium=true
        this.showCredit=false
        this.showDeposit=false

        this.data.deliverMsg(this.id)
      }

      onClickshowPDeposit(){

        this.showDeposit=true
        this.showCredit=false
        this.showMedium=false
        this.data.deliverMsg(this.id)
      }

      onClickCredit(){
        this.sourceCodelist()
        this.cardTypeList();
        this.bankList();
        this.creditList()
        this.branchList()
      this.showCredit=true
      this.showMedium=false
      this.showDeposit=false

      }
      AddCreditCard(){
    
        this.creditRegFg.value.priority=parseInt(this.creditRegFg.value.priority);
        this.creditRegFg.value.minimumPassthroughAmount=parseInt(this.creditRegFg.value.minimumPassthroughAmount);
        this.creditRegFg.value.country=this.addressCountryFormControl.value.countryCode
        this.creditRegFg.value.state=this.addressStateFormControl.value.stateCode
        
       
        this.creditRegFg.value.airport=this.filter.airportInclude +"#"+this.filter.airportExclude
      this.creditRegFg.value.reseller=this.filter.resellerInclude+"#"+this.filter.resellerExclude
      this.creditRegFg.value.dayOfMonth=this.filter.dayOfMonthInclude+"#"+this.filter.dayOfMonthExclude
      if(this.creditRegFg.value.branch){
        this.creditRegFg.value.branch=this.creditRegFg.value.branch?.join(',')||''
      }
      
        this.PaymentConfigService.savecreditCard(this.creditRegFg.value)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.toastMsgService.setMsg({msg : "Credit Card Added Successfully!",msgTitle : "Success", msgType : "I"});
              this.showCreditCardPopup=false
              this.dataFields()
              this.creditList()
  
            } else {
              const body : any = res.body;
              this.registercreditCardErrorMsg(res.status,body?.result);
            } 
    
          },error : (err) => {
    
            this.registercreditCardErrorMsg(err.status,err.error);
          }
        }
      )
    }
    
    registercreditCardErrorMsg(status : number,msg : string) {
      if(this.creditRegFg.value.branch){
        this.creditRegFg.value.branch=this.creditRegFg.value.branch?.split(',')||[]
      }
      if(status >=500) {
        this.toastMsgService.setMsg({msg : "Failed to save Credit Card",msgTitle : "Warning", msgType : "W"});
      } else {
    
        this.toastMsgService.setMsg({msg : "Failed to save Credit Card",msgTitle:  "Warning", msgType : "W"});
      } 
    }

      ProductList(){

        this.PaymentConfigService
        .productList()
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data=res
           this.productdata=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
      cardTypeList(){

        this.PaymentConfigService
        .cardtypeList()
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data=res
           this.cardtypedata=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }


      bankList(){

        this.PaymentConfigService
        .bankList()
        .subscribe({
          next : (res:any) => {
            if(res) {
           let data=res
           this.bankdata=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
      Grouplist(){

        this.AirManagementService
        .grouplist()
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res
           this.groupList=data
           
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
      creditList(){

        this.PaymentConfigService
        .creditCardList()
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res
           this.CreditData=data
           console.log(this.CreditData)
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )
      }
      _filterCountry(countryName: string): Country[] {
        return this.staticDataService.countryCache.filter(option =>
          option.countryName.toLowerCase().indexOf(countryName.toLowerCase()) === 0);
      }
      _filterState(stateName: string): State[] {
        return this.staticDataService.stateCache.filter(option =>
          option.stateName.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
      }
      
      _filterCity(cityName: string): String[] {
        return this.staticDataService.cityCache.filter(option =>
          this.addressStateFormControl?.value?.stateCode ==option.stateCode 
          && option.cityName.toLowerCase().indexOf(cityName.toLowerCase()) === 0).map(c => c.cityName);
      }
      _filterStateByCode(stateCode: string): State[] {
        return this.staticDataService.stateCache.filter(option =>
          option.stateCode.toLowerCase().indexOf(stateCode.toLowerCase()) === 0);
      }
      _filterCountryByCode(countryCode: string): Country[] {
        return this.staticDataService.countryCache.filter(option =>
          option.countryCode.toLowerCase().indexOf(countryCode.toLowerCase()) === 0);
      }
      displayCountrySelectionFn(country : Country) {
        return country ? country.countryName : "";
      }
      
      displayStateSelectionFn(state : State) {
        
        return state ? state.stateName : "";
      }
      onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }
      mmYyyyValidator(control:any) {
        const value = control.value;

        if (!value) {
          return null; // Empty value is valid (you can adjust this based on your requirements)
        }
    
        // MM/YYYY pattern regex
        const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    
        if (!regex.test(value)) {
          return { invalidFormat: true };
        }
    
        // Split the input value into month and year
        const [month, year] = value.split('/').map(Number);
    
        // Create a new date object using the provided month and year
        const inputDate = new Date(year, month - 1); // Note: JavaScript months are zero-based
    
        // Get the current date
        const currentDate = new Date();
    
        // Check if the input date is before the current date
        return inputDate >= currentDate ? null : { pastDate: true };

        
      }
      
   DeleteCredit (){
let request:any={}
request[ "maskedCardNumber"] =this.creditRegFg.value.cardNumber
request["status"]="D"
      this.statusCreditCard(request)
            }
            updateCreditStatus (item:any){
              if(item==="A"){
               
              let request:any={}
             request[ "maskedCardNumber"] =this.creditRegFg.value.cardNumber
              request["status"]=item
              this.statusCreditCard(request)

            }else if(item==="I"){
              let request:any={}
              request[ "maskedCardNumber"] =this.creditRegFg.value.cardNumber
              request["status"]=item
              this.statusCreditCard(request)
             

            }
                          }
              

      statusCreditCard(request:any){
    
      

        this.PaymentConfigService.statuscreditCard(request)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              if(request.status==='D'){
              this.toastMsgService.setMsg({msg : "Credit Card Deleted Successfully!",msgTitle : "Success", msgType : "I"});
              }else{
                this.toastMsgService.setMsg({msg : "Credit Card Updated Successfully!",msgTitle : "Success", msgType : "I"});

              }
              this.showCreditCardPopup=false
              this.dataFields()
              this.creditList()
  
            } else {
              if(request.status==='D'){
                this.toastMsgService.setMsg({msg : "Failed to Delete Credit Card!",msgTitle : "Warning", msgType : "W"});
              }else{
                  this.toastMsgService.setMsg({msg : "Failed to  Update Credit Card!",msgTitle : "warning", msgType : "W"});
  
                }
              const body : any = res.body;
            } 
    
          },error : (err) => {
            this.creditStatus=!this.creditStatus
            if(request.status==='D'){
              this.toastMsgService.setMsg({msg : "Failed to Delete Credit Card",msgTitle : "Warning", msgType : "W"});
            }else{
                this.toastMsgService.setMsg({msg : "Failed to  Update Credit Card!!",msgTitle : "warning", msgType : "W"});

              }
          }
        }
      )
    }

    updateCreditCard(){
      this.creditRegFg.value.priority=parseInt(this.creditRegFg.value.priority);

      this.creditRegFg.value.airport=this.filter.airportInclude +"#"+this.filter.airportExclude
      this.creditRegFg.value.reseller=this.filter.resellerInclude+"#"+this.filter.resellerExclude
      this.creditRegFg.value.dayOfMonth=this.filter.dayOfMonthInclude+"#"+this.filter.dayOfMonthExclude
   let  data= {
        "priority": this.creditRegFg.value.priority,
        "product": this.creditRegFg.value.product,
        "sources": this.creditRegFg.value.sources,
        "subProduct": this.creditRegFg.value.subProduct,
        "maskedCardNumber": this.creditRegFg.value.cardNumber,
        "expiryDate": this.creditRegFg.value.expiryDate,
        "airport": this.creditRegFg.value.airport,
        "reseller": this.creditRegFg.value.reseller,
        "dayOfMonth": this.creditRegFg.value.dayOfMonth,
        "status": this.creditRegFg.value.status,
        "branch": this.creditRegFg.value.branch?.join(',')||'',
        "travelType": this.creditRegFg.value.travelType

    }
    if(this.creditRegFg.value.branch){
      this.creditRegFg.value.branch=this.creditRegFg.value.branch?.join(',')||''
    }
        this.PaymentConfigService.updateCreditCard(data)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
             
                this.toastMsgService.setMsg({msg : "Credit Card Updated Successfully!",msgTitle : "Success", msgType : "I"});

              
              this.showCreditCardPopup=false
              this.dataFields()
              this.creditList()
  
            } else {
           
              
                  this.toastMsgService.setMsg({msg : "Failed to  Update Credit Card!",msgTitle : "warning", msgType : "W"});
  
                
              const body : any = res.body;
            } 
    
          },error : (err) => {
            // this.creditStatus=!this.creditStatus
            
                this.toastMsgService.setMsg({msg : "Failed to  Update Credit Card!!",msgTitle : "Warning", msgType : "W"});

              
          }
        }
      )
    }
    sourceCodeList:any=[]
    sourceCodelist(){
    
      this.AirManagementService
      .sourceCodelist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data=res
         this.sourceCodeList=data
         
          } else {
          
          } 
        },error : (err) => {
    
        }
      }
    )
    }
    disabled(){
      if(this.creditRegFg.value.expiryDate&&this.creditRegFg.value.sources){
        return false
      } return true
    }
    CardLenght:any=16
    changeCardType(item:any){
     if (item.value==='AMEX'){
      this.CardLenght=15
     }else if(item.value==='BTA'){
      this.CardLenght=15
     }else{
      this.CardLenght=16
     }
    }
}
